import React, { useState, useEffect } from 'react';
import { GoogleLogin, googleLogout } from '@react-oauth/google';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ImageChat from './components/ImageChat';
import { tokenManager } from './components/TokenManager';

import Chat from './components/Chat';


function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');

    useEffect(() => {
        // Check if there is a token in localStorage
        const storedToken = localStorage.getItem('token');
        if (storedToken) {
            setToken(storedToken);
            setIsAuthenticated(true);
            console.log('State set from localStorage');
        } else {
            console.log('No valid token or user in localStorage');
        }

        const interval = setInterval(() => {
            let localToken = localStorage.getItem('token')
            if (localToken) {
                tokenManager(localToken, handleLogout);
            }
        }, 14400000); // Check every hour

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    const handleLoginSuccess = async (response) => {
        console.log('Login Success:', response); // Log the response object to see its structure
        const token = response.credential;
        if (token) {
            setToken(token)
            setIsAuthenticated(true);
            localStorage.setItem('token', token);
            console.log('Token and user stored in localStorage');
        } else {
            console.error('Unable to sign in user');
            setIsAuthenticated(false);
        }
    };

    const handleLoginFailure = (error) => {
        console.log('Login Failed:', error);
        setIsAuthenticated(false);
        setUser(user);
    };
    const handleLogout = () => {
        googleLogout();
        setIsAuthenticated(false);
        setUser(null);
        setToken(''); // Clear the token
        localStorage.removeItem('token');
        console.log('Token and user removed from localStorage');
    };
    return (
        <Router>
            <div className="App">
                {isAuthenticated ? (
                    <Routes>
                        <Route path="/" element={<Chat onLogout={handleLogout} token={token} />} />
                        <Route path="/image-chat" element={<ImageChat onLogout={handleLogout} token={token} />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                ) : (
                    <div>
                        <h1>Sign in with Organization Email</h1>
                        <GoogleLogin onSuccess={handleLoginSuccess} onError={handleLoginFailure} />
                    </div>
                )}
            </div>
        </Router>
    );
}

export default App;
